export const fr = {
  Globals: {
    hi: "Bonjour",
    next: "Suivant",
    back: "Retour",
    pred: "fcfcfdfcxsds",
    save: "bvwdrvegave",
  },
};
